
import React from 'react';
import { FacilityOrderTemplateNewFlowInvoiceNoteModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowInvoiceNoteModalStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowInvoiceNoteModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowInvoiceNoteModalStore')
@observer
class FacilityOrderTemplateNewFlowInvoiceNoteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowInvoiceNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowInvoiceNoteModal;
